// Renders a project as "{project} - {customer}" for the places that show it
// as one plain string (badges, list rows). The project name comes first
// because that's the part people scan for; the customer stays because two
// customers can have a project with the same name.
const projectLabel = (project, clients) => {
  const client = clients.find((c) => c.id === project.clientId);
  return `${project.name} - ${client ? client.name : "?"}`;
};

// projectOption builds an AutocompleteSelect option out of a project: the
// project name is the primary label and the customer name the dimmer
// secondary text next to it. AutocompleteSelect filters on both, so typing a
// customer name still finds that customer's projects.
export const projectOption = (project, clients) => {
  const client = clients.find((c) => c.id === project.clientId);
  return { value: project.id, label: project.name, secondary: client ? client.name : "?" };
};

export default projectLabel;
